module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-bounding-box-095f11a7.svg";